import { render } from "./DialogButton.vue?vue&type=template&id=d5638c7a&ts=true"
import script from "./DialogButton.vue?vue&type=script&lang=ts"
export * from "./DialogButton.vue?vue&type=script&lang=ts"

import "./DialogButton.vue?vue&type=style&index=0&id=d5638c7a&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__